<template>
  <div style="margin-bottom: 10px">
    <el-card class="box-card">
      <el-button
        size="medium"
        type="primary"
        plain
        icon="el-icon-plus"
        style="margin-bottom: 10px"
        @click="openDialog(true, null, 0)"
        >新增礼包项</el-button
      >
      <el-table :data="data" border size="small" style="margin-top: 10px">
        <el-table-column
          prop="payPoint"
          label="支付项"
          align="center"
          width="200"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ payPointMap[scope.row.payPoint] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="boughtTimesLimit"
          label="限购次数"
          align="center"
          width="80"
        >
        </el-table-column>
        <el-table-column prop="rewards" label="商品" align="center" width="396">
          <template slot-scope="scope">
            <ShowItems :items="scope.row.rewards" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span
              class="link-button"
              style="color: red"
              @click="remove(scope.$index)"
              >删除</span
            >
            <span
              class="link-button"
              @click="openDialog(false, scope.row, scope.$index)"
              >编辑</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import ShowItems from "./components/ShowItems";

export default {
  data() {
    return {
      data: [],
      payPointMap: {},
    };
  },
  components: {
    ShowItems,
  },
  async created() {
    await this.loadPayPoint();
    if (this.parameter) {
      this.data = JSON.parse(this.parameter).gifts;
    }
  },

  props: {
    parameter: "",
  },

  watch: {},

  computed: {},

  methods: {
    async openDialog(isCreated, entry, index) {
      let that = this;
      this.$dialogutil.open("EditHeroUpgradeGiftDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              that.data.push(param);
            } else {
              this.$set(that.data, index, param);
            }

            await this.updatedParam();
          }
        },
        data: { isCreated, entry },
      });
    },
    async remove(index) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除支付项ID为${this.data[index].payPoint}的礼包？`
        );
        this.data.splice(index, 1);

        await this.updatedParam();
      } catch (error) {}
    },

    async loadPayPoint() {
      let points = await this.$bizutil.loadPayPoint();
      for (let item of points) {
        this.payPointMap[item.id + ""] = item.name;
      }
    },

    async updatedParam() {
      this.$emit("updated", JSON.stringify({ gifts: this.data }));
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

::v-deep .el-table__row td {
  padding: 0px 0;
}
</style>